<template>
  <div class="appBody study-text bg-grey-light ">
    <!--    <div class="shareImg position-fixed cursor-pointer">-->
    <!--      <img @click="onShare" src="/static/img/pro/share.png" alt="" class="">-->
    <!--    </div>-->
    <div>
      <van-nav-bar class="header-exam">
        <template #title>
          <div class="color-base font-13 d-flex align-items-center">
            <img class="daojishi" src="/static/img/session/time.png"/>
            <span class="color-base ml-2 mr-1" v-if="!loading">
              <label class="mr-2 mb-0" v-if="isTiming">{{ secondsCount > 0 ? '倒计时' : '考试时间到' }}</label>
              <label class="mr-2 mb-0" v-else>考试不计时</label>
              <span v-if="isTiming && secondsCount && secondsCount>=0">{{ minute }}:{{ second }}</span>
            </span>
          </div>
        </template>
      </van-nav-bar>
      <van-overlay :show="isSubmit" @click="isSubmit = false">
        <div class="wrapper" @click.stop>
          <div class="block position-relative">
            <p class="mb-0 color-0d font-16">
              确认提交答卷？
            </p>
            <van-circle v-model="currentRate"
                        color="#a6c8ff" layer-color="#2375ff"
                        :clockwise="false"
                        :size="circleSize" :stroke-width="65"
                        :rate="cRate" :speed="100"
                        text=""/>
            <div class="font-12 mt-5r position-absolute d-flex flex-column w-100 align-items-center
             justify-content-center">
              <p class="color-0d mb-0">
                未做题
              </p>
              <p class="color-base mb-0 mt-3 font-14">
                {{ allCount - Object.keys(allOption).length }}题
              </p>
            </div>
            <div class="color-88 font-14 d-flex align-items-center">
              <img class="daojishi" src="/static/img/session/time.png"/>
              <div class="color-base mx-2">
                <label class="mr-2 mb-0" v-if="secondsCount">{{ secondsCount >= 0 ? '倒计时' : '考试时间到' }}</label>
                <label class="mr-2 mb-0" v-else>考试不计时</label>
                <span class="ml-1" v-if="secondsCount && secondsCount>=0">{{ minute }}:{{ second }}</span>
              </div>
            </div>
            <div class=" w-100 d-flex justify-content-center align-items-center">
              <van-button color="#2477ff" :disabled="isSubmmitinng" class="btn-sub font-13 mr-3" plain type="primary"
                          @click="submit">现在交卷
              </van-button>
              <van-button color="#2477ff" class="btn-sub font-13" type="primary" @click="isSubmit=false">继续答题
              </van-button>

            </div>
          </div>
        </div>
      </van-overlay>
      <div class="question-list" v-if="allQuetion">
        <div class="" v-for="(item, index) in allQuetion" :key="item.id" :id="'question_'+item.id">

          <div class="question-card bg-white"
               v-if="num === index && item.itemType !== 'section'">
            <div class="d-flex align-items-start font-14 color-33 mb-3">
              <div class="bg-base hao text-white">{{ item.indexShow|numberFormat }}</div>
              <p class="mb-0 w-100">
                {{ item.title }}（{{ getTypeTxt(item.type) }}）
              </p>
            </div>
            <div class="font-12 color-33">
              <label v-if="item.type==='single' || item.type==='multiple'||item.type==='trueOrFalse'"
                     class="w-100 option mb-3"
                     v-for="opt in item.options" :key="opt.id" :id="opt.id">
                <input v-if="item.type==='single'||item.type==='trueOrFalse'" type="radio"
                       @change="changeOpt(item, opt, $event)"
                       :name="item.title" v-model="item.userExamItem.answers[0]" :value="opt.id">

                <input v-if="item.type==='multiple'" type="checkbox" @change="changeOpt(item, opt, $event)"
                       :name="item.title" v-model="item.userExamItem.answers" :value="opt.id">
                {{ opt.letter }}.<span class="ml-1">{{ opt.title }}</span>
              </label>
              <van-field class="border my-3 rounded-lg" v-if="item.type==='opening'"
                         v-model="item.userExamItem.answers[0]"
                         @blur="changeOpt(item, item.userExamItem.answers[0], $event)"
                         rows="3"
                         autosize
                         type="textarea"
              />
            </div>
          </div>
          <div class="section-bg" v-else-if="num === index &&item.itemType === 'section'">
            <div class="title">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>

      <div class="text-footer">
        <div class="change-ti d-flex justify-content-center align-items-center">
          <div class="nextBtn mr-20" :class="{'noMore': isNoFirst, 'canClick': !isNoFirst}"
               @click="previous()">
            上一题
          </div>
          <div class="nextBtn rounded-xlg canClick" v-if="!isNoLast"
               @click="next()">
            下一题
          </div>
          <div class="nextBtn rounded-xlg canClick" v-if="isNoLast"
               @click="goSubmit">
            提交
          </div>

        </div>
        <div class="error-add d-flex justify-content-between">
          <van-button color="#2474ff" class="rounded-xlg submitBtn" @click="goSubmit">交卷</van-button>
          <div class="d-flex align-items-center color-00 font-16 cursor-pointer"
               @click="showAllOption">
            <img class="mr-2 w-15px" src="/static/img/session/select.png" alt="">
            {{ Object.keys(allOption).length }}/{{ allCount }}
          </div>
        </div>
        <van-popup class="w-100 d-flex flex-column xuhao" v-if="isShow"
                   v-model="isShow" position="bottom">
          <div class="w-100 error-add bg-error-add d-flex justify-content-between">
            <van-button color="#2474ff" class="rounded-xlg submitBtn" @click="goSubmit">交卷</van-button>
            <div class="d-flex align-items-center color-00 font-16 cursor-pointer">
              <img class="mr-2 w-15px" src="/static/img/session/select2.png" alt="">
              {{ Object.keys(allOption).length }}/{{ allCount }}
            </div>
          </div>

          <div class="d-flex bg-white flex-wrap px-2">
            <div class="biaoqian" v-for="(qs, index) in allQuetion">
            <span class="m-2 hao" v-if="qs.itemType === 'section'" @click="goQuestion(index)">
            题干
            </span>
              <span v-else class="m-2 hao" @click="goQuestion(index)"
                    :class="{'bg-base-light': qs.userExamItem && qs.userExamItem.answers && qs.userExamItem.answers.length>0  }">
              {{ qs.indexShow }}
             </span>
            </div>
          </div>
        </van-popup>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {Button, NavBar, Overlay, Circle, Field, Popup, Dialog} from 'vant';
import {mapState} from "vuex";

Vue.use(Popup);
Vue.use(NavBar);
Vue.use(Button);
Vue.use(Overlay);
Vue.use(Circle);
Vue.use(Field);
Vue.use(Dialog);
export default {
  name: "examText",
  props: ['examId', 'userExId', 'durationFromSession'],
  data() {
    return {
      durations: 0,
      secondsCount: 0,
      cRate: 10,
      isTiming: false,
      currentExamItem: {},
      examItemList: [],
      userExam: {},
      totalCnt: 0,
      submitCnt: 0,
      finishedTime: 0,
      serverCurrentTime: 0,
      data: {},
      exId: '',
      userEId: '',
      username: '',
      allQuetion: [],
      quetionsArr: [],
      isNoFirst: true,
      isNoLast: true,
      num: 0,
      allOption: [],
      isShow: false,
      optContent: [],
      minutes: 0,
      seconds: 0,
      sum: 0,
      isPc: false,
      currentRate: 0,
      circleSize: '8rem',
      currentTimer: '',
      typeTxt: '',
      exam: {},
      examInfo: {},
      isSubmit: false,
      nowTime: 0,
      timeGap: 0,
      indexShow: 0,
      allCount: 0,
      currentAnswers: [],
      isSubmmitinng: false,
      loading: false
    }
  },

  destroyed() {
    clearInterval(this.currentTimer);
    clearInterval(this.timeInterval);
  },
  created() {

    if (this.userExId) {
      this.userEId = this.userExId;
      console.log(this.userEId)
    }
    if (this.durationFromSession) {
      this.durations = this.durationFromSession;
    }
  },
  mounted() {
    this.exId = this.$route.params['id'];
    if (this.$route.query['duration']) {
      this.durations = this.$route.query['duration'];
    }
    if (this.$route.query['uExamId']) {
      this.userEId = this.$route.query['uExamId'];
    }
    this.calTime();
    this.loadData();
    this.colorFun();
  },
  methods: {
    onClickLeft() {
      this.$router.push('/course/re-exam/' + this.exId);
    },
    // onShare() {
    //   //把生成海报需要的信息传入cookie
    //   this.shareObj = this.data;
    //   this.shareObj.qrcodeUrl = window.location.href;
    //   this.shareObj.fromPageType = 'session';
    //   localStorage.setItem('share_obj', JSON.stringify(this.shareObj));
    //   this.$router.push('/share-poster');
    // },
    showAllOption() {
      this.isShow = !this.isShow;
    },
    loadData() {
      if (this.userEId) {
        console.log(1)
        //获取正在考试的试卷
        this.getUserExamForLearner();
      } else {
        console.log(2)
        //生成试卷
        this.addUserExam();
      }
    },
    getTypeTxt(type) {
      switch (type) {
        case 'single':
          return '单选';
        case 'multiple':
          return '多选';
        case 'trueOrFalse':
          return '判断';
        case 'opening':
          return '主观';
        default:
          return '';
      }
    },
    getAllQuestion() {
      this.userExam = this.data;
      if (this.data && this.durations > 0) {
        //计时
        let _this = this;
        this.currentTimer = setInterval(() => {
          _this.getServerTime();
        }, 60000);
        _this.isTiming = true;
        if (this.data.finishedTime) {
          let finishedTime = this.data.finishedTime;
          this.secondsCount = Math.ceil((finishedTime - new Date().getTime() - this.timeGap) / 1000);
          this.timeInterval = setInterval(() => {
            this.secondsCount--;
            _this.calTime();
          }, 1000);
        }
      } else {
        //不计时
        this.isTiming = false;
      }
      if (this.data && this.data.questions && this.data.questions.length > 0) {
        this.allQuetion = this.data.questions;
        if (this.userEId === '') {
          this.userEId = this.data.id;
        }

        this.num = this.allOption.length > 0 ? this.allOption.length - 2 : 0;
        if (this.allOption && this.allOption.length > 0) {
          this.colorFun();
        }
        for (let examItemModel of this.allQuetion) {
          if (examItemModel.userExamItem &&
            examItemModel.userExamItem.answers &&
            examItemModel.userExamItem.answers.length > 0) {
            this.allOption[examItemModel.id] = examItemModel.userExamItem.answers;
          }
          //单选 多选 判断 添加 A B C D
          if (examItemModel.options && examItemModel.options.length > 0) {
            for (let j = 0; j < examItemModel.options.length; j++) {
              if (j >= 26) {
                break;
              }
              examItemModel.options[j].letter = this.LetterList[j];
            }
          }
          //去掉题干序号
          if (examItemModel.itemType === 'section') {
            examItemModel.indexShow = -1;
          } else {
            this.indexShow++;
            this.allCount++;
            examItemModel.indexShow = this.indexShow;
          }
        }

      }
    },
    //是否有上一题下一题的判断
    colorFun() {
      this.isNoFirst = this.num === 0 ? true : false;
      this.isNoLast = this.num === this.allQuetion.length - 1 ? true : false;
    },
    getServerTime() {
      this.$store.dispatch('getServerCurrentTimeUrl').then((res) => {
        this.serverCurrentTime = parseInt(res.data);
        this.timeGap = new Date().getTime() - this.serverCurrentTime; //当前时间和服务器时间差
      })
    },
    calTime() {
      if (this.isTiming) {
        if (this.secondsCount <= 0) {
          //已结束
          this.isSubmit = false;
          this.submit();
          clearInterval(this.timeInterval);
          clearInterval(this.currentTimer);
        } else {
          this.minutes = Math.floor(this.secondsCount / 60);
          this.seconds = this.secondsCount % 60;
        }
      }
    },
    addUserExam() {
      this.loading = true;
      this.$store.dispatch('addUserExamUrl', {id: this.exId}).then((res) => {
        this.data = res;
        this.loading = false;
        this.getAllQuestion();
      });
    },
    getUserExamForLearner() {
      this.loading = true;
      this.$store.dispatch('getUserExamForLearnerUrl', {examId: this.exId, userExamId: this.userEId}).then((res) => {
        this.data = res;
        if (this.data.needChange !== null && this.data.needChange !== undefined) {
          Dialog.alert({
            title: '提示',
            message: this.data.needChange ? '您有未完成的考试，试卷内容发生更改，请您作答' : '您有未完成的考试，试卷发生更改，请您检查之前作答过的题目',
          }).then(() => {
            // on close
          });
        }
        this.loading = false;
        this.getAllQuestion();
      });
    },
    previous() {
      this.optContent = [];
      if (this.num === 0) {
        this.num = 0;
        this.isNoFirst = true;
        this.$toast('已经是第一题了')
      } else if (this.num === 1) {
        this.num -= 1;
        this.isNoFirst = true;

      } else {
        this.num -= 1;
        this.isNoFirst = false;
      }
      this.isNoLast = false;
    },
    next() {
      this.optContent = [];
      if (this.num < this.allQuetion.length - 2) {
        this.num += 1;
        this.isNoLast = false;
      } else if (this.num === this.allQuetion.length - 2) {
        this.num += 1;
        this.isNoLast = true;
      } else {
        this.isNoLast = true;
      }
      this.isNoFirst = false;
      //点击下一题，提交本题的答案
      this.submitSingleAnswer(this.num - 1);
    },
    submitSingleAnswer(i) {
      if (this.allQuetion[i] && this.allQuetion[i].userExamItem && this.allQuetion[i].userExamItem.answers && this.allQuetion[i].userExamItem.answers.length > 0) {
        this.$store.dispatch('updateUserExamItemUrl', {
          examId: this.exId,
          userExamId: this.userEId,
          examItemId: this.allQuetion[i].id,
          model: {answers: this.allQuetion[i].userExamItem.answers}
        })
      }
    },
    goQuestion(i) {
      this.isShow = false;
      if (i !== this.num) {
        //切换题时，提交上一题的答案
        this.submitSingleAnswer(this.num);
        this.num = i;
      }
      this.colorFun();
    },
    changeOpt(question, opt, event) {
      let status = event.target.checked;

      //初始化
      if (question.type === 'opening') {
        this.allOption[question.id] = [];
        this.allOption[question.id].push(opt);
      } else {
        this.optContent = (this.allOption[question.id] && this.allOption[question.id].length > 0) ? this.allOption[question.id] : [];
        if (status) { //选中
          if (this.optContent.indexOf(opt.id) < 0) {
            this.optContent.push(opt.id)
          }
        } else {
          this.optContent = this.optContent.filter(v => v !== opt.id);
        }
        this.allOption[question.id] = this.optContent;
      }
    },
    handleNu(n) {
      return n < 10 ? '0' + n : '' + n
    },
    goSubmit() {
      this.isSubmit = true;
      this.isShow = false;
      this.isSubmmitinng = false;
      this.cRate = ((this.allCount - Object.keys(this.allOption).length) / this.allCount) * 100;
    },
    subFunc() {
      this.$store.dispatch('updateUserExamFinishedUrl', {
        examId: this.exId,
        userExamId: this.userEId
      }).then((res) => {
        this.$toast('您已成功交卷，即将为您展示考试结果！');
        this.isSubmit = false;
        let _this = this;
        setTimeout(function () {
          _this.$router.push({path: `/course/exam-result/${_this.exId}`})
        }, 2000)
      }, (error) => {
        //这个错误，正常提交，但不记录学习，正常跳转到结果页面
        if (error.response.data.errorType === 'UserProjectNotInStartTimeException') {
          this.$toast(this.recordStudyTip);
          this.isSubmit = false;
          let _this = this;
          setTimeout(function () {
            _this.$router.push({path: `/course/exam-result/${_this.exId}`})
          }, 2000)
        } else {
          this.$toast('交卷失败！');
        }
        this.isSubmmitinng = true;
      })
    },
    submit() {
      this.isSubmit = true;
      //1、关闭倒计时
      clearInterval(this.timeInterval);
      let needSubmit = false;
      if (this.allQuetion[this.num] && this.allOption[this.allQuetion[this.num].id] && this.allOption[this.allQuetion[this.num].id].length > 0) {
        needSubmit = true;
      } else {
        this.$toast('当前题目尚未作答');
      }

      if (needSubmit) {
        this.$store.dispatch('updateUserExamItemUrl', {
          examId: this.exId,
          userExamId: this.userEId,
          examItemId: this.allQuetion[this.num].id,
          model: {answers: this.allQuetion[this.num].userExamItem.answers}
        }).then((res) => {
          this.subFunc();
        }, (error) => {
          //正常提交，但不记录学习，正常走提交方法
          if(error.response.data.errorType === 'UserExamAlreadyFinishedException') {
            this.subFunc();
          }
        })
      }
    },
  },
  watch: {
    second: {
      handler(newVal) {
        this.handleNu(newVal)
      }
    },
    minute: {
      handler(newVal) {
        this.handleNu(newVal)
      }
    },
  },
  computed: {
    second: function () {
      return this.handleNu(this.seconds)
    },
    minute: function () {
      return this.handleNu(this.minutes)
    },
    ...mapState({
      LetterList: state => state.LetterList,
      recordStudyTip: state => state.recordStudy
    })
  }
}
</script>

<style scoped lang="scss">
$browser-default-font-size: 16px !default;
@function pxTorem($px) {
  @return $px / $browser-default-font-size * 1rem;
}

.section-bg {
  padding-top: pxTorem(44px);
  min-height: pxTorem(362px);
  background: url("/static/img/pro/section_bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  .title {
    margin-left: pxTorem(28px);
    margin-right: pxTorem(28px);
    font-size: pxTorem(14px);
    color: #333333;
  }
}

.question-list {

}

.question-card {
  border-radius: .25rem;
  padding: pxTorem(16px) pxTorem(16px) pxTorem(0px) pxTorem(22px);
  margin: pxTorem(26px) pxTorem(20px) pxTorem(0px) pxTorem(20px);
  min-height: pxTorem(64px);
  max-height: 44vh;
  overflow-y: auto;
  box-shadow: 1px 1px 0 1px #9999991c;
  background-color: white;
}

.study-text .change-btn {
  height: 1rem;
}

.study-text .van-nav-bar .van-icon {
  color: #333333;
  font-size: 2rem;
}

.study-text .van-nav-bar__title {
  font-size: 1.5rem;
}


.study-text .van-nav-bar__right {
  margin-top: .125rem;
}

.study-text .hao {
  border-radius: pxTorem(8px);
  width: pxTorem(27px);
  height: pxTorem(27px);
  margin-right: pxTorem(14px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.xuhao {
  max-width: 640px;
  margin: 0 auto;
  right: 0;
  left: 0;
}

.study-text .van-radio__label {
  margin-left: 16px;
}


.text-footer {
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  /*max-width: 640px;*/
  margin: 0 auto;
}

.text-footer .change-ti {
  padding-bottom: 5vh;
}

.error-add {
  background-color: #a1a1a1;
  border-bottom: 1px solid #eeeeee;
  padding: pxTorem(10px) pxTorem(20px) pxTorem(10px) pxTorem(20px);
  max-width: 640px;
  margin: 0 auto;
}

.bg-error-add {
  background-color: #ffffff;
}

.study-text .option {
  display: flex;
  align-items: center;
  width: 100%;
  /*height: pxTorem(40px);*/
  border-radius: .75rem;
  cursor: pointer;
}

.study-text .option input {
  margin-right: 1.5rem;
  width: 1rem;
  height: 1rem;
  flex: none;
  cursor: pointer;
}

.nextBtn {
  padding: pxTorem(0px) pxTorem(24px) pxTorem(0px) pxTorem(24px);
  font-size: pxTorem(13px);
  height: pxTorem(30px);
  cursor: pointer;
  line-height: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: pxTorem(10px);
}

.startBtn {
  margin-top: 3rem;
  border-radius: 1.5rem;
  font-size: 1.085rem;
  height: 3rem;
  cursor: pointer;
  line-height: 1.25;
  display: flex;
  justify-content: center;
  align-items: center;
}

.daojishi {
  width: .75rem;
  height: .75rem;
  overflow: hidden;
}

.noMore {
  color: rgb(255, 255, 255);
  background: rgb(204, 204, 204);
  border-color: rgb(204, 204, 204);
}

.canClick {
  color: rgb(255, 255, 255);
  background: #2474ff;
  border-color: #2474ff;
}

.bg-base-light {
  background-color: #2474ff20;
  border-color: #2474ff20 !important;
}

.bg-red-light {
  background-color: #ff000021;
}

.biaoqian {
  cursor: pointer;
  color: #888888;
  display: flex;
  justify-content: center;
  align-items: center;
}

.biaoqian .hao {
  width: pxTorem(40px);
  height: pxTorem(40px);
  overflow: hidden;
  border-radius: 50%;
  border: 1px solid #777777;
  color: #777777;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: .5rem 1rem;
}

.biaoqian .hao:hover {
  border: 1px solid #2474ff;
}

.van-nav-bar__left {
  max-width: 10rem;
}

.submitBtn {
  height: pxTorem(30px);
  padding: pxTorem(0px) pxTorem(32px) pxTorem(0px) pxTorem(32px);
  border-radius: pxTorem(10px);
  font-size: pxTorem(13px) !important;
}

.res-icon {
  width: 1.25rem;
  height: 1.35rem;
  overflow: hidden;
  flex: none;
}

.color-red {
  color: #dc3545;
}

.study-down .van-dropdown-menu__item {
  width: 116px;
}

.study-down .van-dropdown-menu__title {
  font-size: 1.5rem;
}

.study-down .van-dropdown-menu__title::after {
  border-color: transparent transparent #515a6e #515a6e;
}

.study-down .van-dropdown-item__content {
  width: 14rem;
  left: 50%;
  margin-left: -7rem;
}

.study-down .van-dropdown-item {
  max-width: 640px;
  margin: 0 auto;
}

.study-down .van-dropdown-item__icon {
  font-size: 1.25rem !important;
  color: #29d9b5 !important;
}

.study-down .van-cell__title {
  font-size: 1rem;
}

.study-down .van-dropdown-item__option--active {
  color: #29d9b5;
}

.study-down .van-dropdown-menu__title--active {
  color: #29d9b5 !important;
}

.chengji {
  height: 11rem;
  /*background-image: url(/static/img/chengji.png);*/
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: pxTorem(320px);
  height: pxTorem(320px);
  overflow: hidden;
  background-color: #fff;
  border-radius: pxTorem(10px);
  padding: pxTorem(32px) pxTorem(0px) pxTorem(24px) pxTorem(0px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.w-15px {
  width: pxTorem(12px);
}

.mt-5r {
  margin-top: 5rem;
}

.btn-sub {
  height: pxTorem(40px);
  width: pxTorem(104px);
  border-radius: pxTorem(10px);
}

</style>
